import { useAuth } from "../../../auth/AuthContext";
import routes from "../../../routes/routes";
import { useNavigate } from "react-router-dom";

export default function ThemeRedirect({ children }) {
  const { activeCompany, loadingActiveCompany } = useAuth();
  const navigate = useNavigate();
  if (loadingActiveCompany) return <></>;
  // allow access only to a reseller
  if (!activeCompany.is_reseller) navigate(routes.Settings.root);
  return children;
}
